function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.2031,
  cy: 10.2024,
  r: 10,
  fill: "#083261"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.04158 11.8748C9.04158 11.343 9.1592 10.9032 9.39443 10.5555C9.63988 10.2078 9.99272 9.82425 10.4529 9.40493C10.7904 9.09811 11.0359 8.84243 11.1893 8.63789C11.3529 8.42311 11.4348 8.18277 11.4348 7.91686C11.4348 7.53845 11.2814 7.24186 10.9745 7.02709C10.6779 6.80209 10.2791 6.68959 9.77795 6.68959C9.29727 6.68959 8.86772 6.79186 8.48931 6.99641C8.12113 7.19073 7.8092 7.46686 7.55352 7.82482L5.69727 6.73561C6.12681 6.08107 6.70465 5.57482 7.43079 5.21686C8.16715 4.85891 9.03647 4.67993 10.0387 4.67993C11.2149 4.67993 12.1558 4.9305 12.8615 5.43164C13.5774 5.93277 13.9353 6.62823 13.9353 7.518C13.9353 7.93732 13.8637 8.3055 13.7206 8.62255C13.5876 8.93959 13.4189 9.21061 13.2143 9.43561C13.02 9.65039 12.7643 9.90096 12.4473 10.1873C12.0689 10.5248 11.7927 10.8112 11.6189 11.0464C11.445 11.2714 11.3581 11.5475 11.3581 11.8748H9.04158ZM10.2075 15.7254C9.78818 15.7254 9.43533 15.5924 9.14897 15.3265C8.87283 15.0504 8.73477 14.718 8.73477 14.3294C8.73477 13.9407 8.87283 13.6186 9.14897 13.3629C9.42511 13.097 9.77795 12.964 10.2075 12.964C10.637 12.964 10.9899 13.097 11.266 13.3629C11.5422 13.6186 11.6802 13.9407 11.6802 14.3294C11.6802 14.718 11.537 15.0504 11.2507 15.3265C10.9745 15.5924 10.6268 15.7254 10.2075 15.7254Z",
  fill: "white"
});

var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question-mark.a52deb0d.svg";
export { ForwardRef as ReactComponent };